import Vue from "vue";
import ColorView from "color-view";
import AnyFormat from "../lib/any-format.js";
import server from "../remotes/server.js";

Vue.use(ColorView);
Vue.use(AnyFormat);

Vue.prototype.$remotes = {
    server
};

Vue.config.productionTip = false;

export default Vue;
